import React, { FC } from "react";
import { useStore } from "effector-react";
import { SettingsEndpoint } from "../../store/endpoints";
import stl from "./ImportAnnouncement.module.scss";

const ImportantAnnouncement: FC = () => {
  const { data: settings } = useStore(SettingsEndpoint.store);
  return settings?.important_announcement_title ? (
    <div className={stl.block}>
      <span className={stl.title}>
        {settings?.important_announcement_title}
      </span>
      {settings?.important_announcement_text}
    </div>
  ) : null;
};

export default ImportantAnnouncement;
